const createEvent = openHouseData => ({
  description: `Listing URL: ${openHouseData.listingLink} ${
    openHouseData.streamingUrl
      ? `Streaming URL: ${openHouseData.streamingUrl}`
      : ""
  }`.trim(),
  end: new Date(openHouseData.time.endsAt),
  location: openHouseData.listingAddress,
  start: new Date(openHouseData.time.startsAt),
  title: "Open House",
  url: openHouseData.streamingUrl
});

export default createEvent;
